<template>
  <div class="step">
    <el-steps :active="active" align-center v-if="config.setForm.isprocess">
    <el-step
      :title="language == 'cn' ? item.title : item.en_title"
      v-for="item in menuData"
      :key="item.title"
    ></el-step>
  </el-steps>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState([
      // 映射 this.count 为 store.state.count
      "menuData",
      'config',
    ]),
  },
  watch: {
    menuData(newValue) {
      if (newValue.length > 0) {
        newValue.forEach((item, index) => {
          if (item.path == this.$route.name) {
            this.active = index+1;
          }
        });
      }
    },
  },
  data() {
    return {
      values: this.value,
      active: 0,
      language: sessionStorage.getItem("language") || "cn",
    };
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped>
.list {
  display: flex;
  align-items: center;
  width: 100%;
}

.list .num {
  width: 34px;
  height: 34px;
  line-height: 34px;
  display: inline-block;
  border-radius: 50%;
  text-align: center;
  border: 1px solid #878b9d;
}

.list .active {
  background: #026abb;
  color: #fff;
  border: 1px solid transparent;
}

.list .bor {
  flex: 1;
  height: 1px;
  background-color: red;
}

.list:last-child .bor {
  display: none;
}

.row {
  justify-content: center;
}

@media screen and (max-width: 768px) {
  .step /deep/.el-step__title{
  font-size: 12px !important;
}

}

@media screen and (max-width: 576px) {
  .step /deep/.el-step__title{
  font-size: 12px !important;
}
}
</style>
